/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentPreview } from '../../models/document-preview';

export interface DocumentGetDocument$Params {

/**
 * GUID of the document
 */
  documentId: string;
}

export function documentGetDocument(http: HttpClient, rootUrl: string, params: DocumentGetDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentPreview>> {
  const rb = new RequestBuilder(rootUrl, documentGetDocument.PATH, 'get');
  if (params) {
    rb.path('documentId', params.documentId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DocumentPreview>;
    })
  );
}

documentGetDocument.PATH = '/document/{documentId}';
